export default "__VITE_ASSET__a$gNHsiR__"